import { useFlag } from '@openfeature/react-sdk';

import { availableFeatureFlags } from './feature-flags-provider';

export const useCanUseTopLeftLogoInTheme = () =>
  useFlag(availableFeatureFlags.CAN_USE_TOP_LEFT_LOGO_IN_THEME, false);
